import React, { Component } from 'react';
import { connect } from 'react-redux';
import { formValueSelector } from 'redux-form';
import styles from './style.module.css';
import { percent, numberWithCommas, range } from '../../../../helpers';
import StepFiveForm from '../../components/forms/step-five';
import InfoBox from '../../../../common/components/info-box';
import FixedHeading from '../../../../common/components/fixed-heading';
import { formDetails as StepOneFormDetails } from '../../components/forms/step-one';
import { formDetails as StepFiveFormDetails } from '../../components/forms/step-five';

class StepFive extends Component {
    render() {
        const {
            props: {
                income,
                expense
            }
        } = this;

        const tooltip = {
            title: 'Recommendation',
            content: <span>You're running a little hot on {(StepFiveFormDetails.title).toLowerCase()} expenses at <strong className={styles.redText}>{percent(expense, income)}%</strong> of your net income.</span>
        };

        let message = <span>Your net income is <strong>${numberWithCommas(income)}</strong>.</span>;

        if (percent(expense, income) > 0) {
            message = <span><span className={styles.hideMobile}>Currently </span><strong>{percent(expense, income)}%</strong> of your <strong>${numberWithCommas(income)}</strong> net income.</span>;
        }

        return (
            <div className={styles.page}>
                <p className={styles.topTitle}>Monthly Expenses</p>
                <h1 className={styles.mainTitle}>{StepFiveFormDetails.title}</h1>
                <p className={styles.text}>On average, {(StepFiveFormDetails.title).toLowerCase()} expenses for a household range between <strong>{range(`${StepFiveFormDetails.range.low}%`, `${StepFiveFormDetails.range.high}%`)}</strong> of your total net income.</p>
                <FixedHeading
                    title={`${StepFiveFormDetails.title} Expenses`}
                    content={message}
                />
                <StepFiveForm/>
                {
                    percent(expense, income) > StepFiveFormDetails.range.high &&
                    <InfoBox
                        title={tooltip.title}
                        content={tooltip.content}
                    />
                }
            </div>
        );
    }
}

const selector = formValueSelector(StepFiveFormDetails.formName);
const StepOneForm = formValueSelector(StepOneFormDetails.formName);

export default connect(state => {
    const expense = selector(state, StepFiveFormDetails.totalKey);
    const income = StepOneForm(state, StepOneFormDetails.totalKey);

    return {
        income: income ? income : 0,
        expense: expense ? expense : 0
    }
})(StepFive);
